import React from "react";
import "./dorm-list-list.less";
import { withRouter } from "react-router";
import { ListView, PullToRefresh, ActivityIndicator, Toast, Button } from "antd-mobile";
import ReactDOM  from "react-dom";
import { manageListApi } from "@/api/sany";
import  moment from "moment";
import { getSanyPhone } from "@/util/storage";
import Cookies from "universal-cookie";
const cookie = new Cookies()

const APullToRefresh: any = PullToRefresh
const Footer = ({ isLoading, isHasMore, noHasMore }: any) => {
  if (!isHasMore) {
    return noHasMore || <div className="text-center">没有更多啦</div>
  }
  return (
    <div className="flex-lvc">
      {isLoading ? <ActivityIndicator text="加载中..." /> : ''}
    </div>
  )
}

@(withRouter as any)
export default class DormListList extends React.Component<any, any> {
  lv!: any
  dataBlobs: any = []
  rowIDs: any = []
  isHasMore = false
  pageIndex = 1


  constructor(prop: any) {
    super(prop)
    this.lv = React.createRef()
    const getSectionData = (dataBlob: any, sectionId: any) => dataBlob[sectionId]
    const getRowData = (dataBlob: any, sectionId: any, rowId: any) => dataBlob[rowId]
    const dataSource = new ListView.DataSource({
      getRowData,
      getSectionHeaderData: getSectionData,
      rowHasChanged: (row1: any, row2: any) => row1 !== row2,
      sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2,
    })
    this.rowIDs[0] = []
    this.state = {
      dataSource,
      isLoading: false,
      height: document.documentElement.clientHeight * 3 / 4
    }
    this.onRefresh = this.onRefresh.bind(this)
    this.onEndReached = this.onEndReached.bind(this)
    this.fetchData = this.fetchData.bind(this)
    this.cellClick = this.cellClick.bind(this)
    this.bookingRoom = this.bookingRoom.bind(this)
  }

  componentDidMount() {
    const height = document.documentElement.clientHeight - (ReactDOM.findDOMNode(this.lv) as any).getBoundingClientRect().top
    this.setState({
      height
    })
    this.fetchData()
  }

  async onRefresh() {
    if (this.state.isLoading) {
      return
    }
    this.pageIndex = 1
    this.rowIDs[0] = []
    this.dataBlobs['section0'] = 'section0'
    this.fetchData()
  }

  async onEndReached() {
    if (this.state.isLoading || !this.isHasMore) {
      return
    }
    this.pageIndex++
    this.fetchData()
  }

  async fetchData() {
    const phone = getSanyPhone()
    // const phone = 18337719432
    const type = this.props.type
    this.setState({
      isLoading: true
    })
    if (type === '3') {
      Toast.loading('加载中...')
    }
    this.isHasMore = true
    const {data} = await manageListApi({ phone: phone, room_property: type })
    if (type === '3') {
      Toast.hide()
    }
    this.isHasMore = false
    this.setState({
      isLoading: false
    })
    if (data.code === 'SUCCESS') {
      // this.isHasMore = !data.is_end
      // if (data.data && data.data.length === 0) {
      //   this.isHasMore = false
      // }
      data.data.forEach((item: any, index: number) => {
        const rowName = item.id
        this.dataBlobs[rowName] = item
        this.rowIDs[0].push(rowName)
      })

      const sectionIDs = [0]
      this.rowIDs = [...this.rowIDs]
      this.setState({
        dataSource: this.state.dataSource.cloneWithRowsAndSections(
          this.dataBlobs,
          sectionIDs,
          this.rowIDs,
        ),
      })
    } else {
      Toast.info(data.msg)
    }
  }

  //查看详情
  cellClick(item: any) {
    cookie.set('rechargeListId', item.id)
    if (item.type === 'reserve') {
      if (item.status === 'reject' || item.status === 'expired' || item.status === 'cancelled') {
        this.props.history.push({
          pathname: '/sany/booking-detail',
          state: { id: item.id },
        })
      } else if (item.status === 'checkout') {
        this.props.history.push({
          pathname: '/sany/checkout',
          state: { reserveId: item.id },
        })
      }
       else {
        this.props.history.push({
          pathname: '/sany/dorm-manage',
          state: { id: item.id },
        })
      }
    } else if (item.type === 'queue') {
      this.props.history.push({
        pathname: '/sany/lineup-detail',
        query: { id: item.id },
      })
    }
  }
  bookingRoom(val: any) {
    this.props.history.push({pathname: '/sany/book-room',state: {type: 'reservation',propertyType:val}})
    sessionStorage.setItem('reservationType', 'reservation')
  }
  render() {
    const { isRefreshing, isLoading } = this.state
    const { isHasMore } = this

    const row = (rowData: any, sectionID: any, rowID: any) => {
      let statusClassName = 'status-text '
      switch (rowData.status) {
        case 'change_bed':
          statusClassName += 'changing'
          break;
        case 'bed_continue':
          statusClassName += 'wait-continue'
          break
        case 'relet':
          statusClassName += 'wait-continue'
          break
        case 'refund_room':
          statusClassName += 'checkout'
          break
        case 'pending':
          if (rowData.type === 'reserve') {
            statusClassName += 'wait-sign'
          } else if (rowData.type === 'queue') {
            statusClassName += 'liveing'
          }
          break
        case 'sign_up':
          if (rowData.type === 'reserve') {
            statusClassName += 'wait-sign'
          } else {
            statusClassName += 'liveing'
          }
          break
        case 'live':
          statusClassName += 'liveing'
          break

        default:
          statusClassName += 'invalid'
          break;
      }
      const startDay = rowData.start_day.length > 5 ? moment(rowData.start_day).format('yyyy-MM-DD') : rowData.start_day
      const endDay = rowData.end_day.length > 5 ? moment(rowData.end_day).format('yyyy-MM-DD') : rowData.end_day
      // 普通cell
      const normalView = (rowData: any) => {
        return (
          <div className="bill-cell">
            <div className="between-row" style={{borderBottom: '1px solid #eeeeee'}}>
              <span style={{color: '#333333', fontSize: '18px'}}>{rowData.store_name}</span>
              <span className={statusClassName}>{rowData.status_info}</span>
            </div>
            <div className="between-row">
              <span style={{color: '#949494', fontSize: '14px'}}>{rowData.building_no}<span>{rowData.building_no ? '栋' : ''}</span> {rowData.room_no} {rowData.bed_no}</span>
              <span style={{color: '#949494', fontSize: '14px'}}>{rowData.room_type_name}</span>
            </div>
            <div className="between-row">
              <span style={{color: rowData.property === '员工宿舍' ? '#7fc5ff' : '#cf6568', fontSize: '14px'}}>{rowData.property}</span>
              <span style={{color: '#949494', fontSize: '12px'}}>{startDay}~{endDay}</span>
            </div>
          </div>
        )
      }
      // 排队cell
      const lineupView = (rowData: any) => {
        return (
          <div className="bill-cell">
            <div className="between-row" style={{borderBottom: '1px solid #eeeeee'}}>
              <span style={{color: '#333333', fontSize: '18px'}}>{rowData.store_name}</span>
              <span className={statusClassName}>{rowData.status_info}</span>
            </div>
            <div className="between-row">
              <span style={{color: rowData.property === '员工宿舍' ? '#7fc5ff' : '#cf6568', fontSize: '14px'}}>{rowData.property}</span>
              <span style={{color: '#949494', fontSize: '14px'}}>{rowData.room_type_name}</span>
            </div>
            <div className="lineup-bottom">
              {rowData.status === 'pending' ? <span style={{color: '#333333', fontSize: '14px'}}>等待中：{rowData.queue_count}人</span> : <span></span> }
              <span style={{color: '#949494', fontSize: '12px'}}>编号：{rowData.code}</span>
            </div>
          </div>
        )
      }
      return (
        <div key={rowID} className="bill-cell-bg" onClick={() => this.cellClick(rowData)}>
          { rowData.type === 'reserve' ? normalView(rowData) : lineupView(rowData) }
        </div>
      )
    }

    return (
      <div className="dorm-list-list">
        <ListView
        ref={(el: any) => (this.lv = el)}
        dataSource={this.state.dataSource}
        renderFooter={() => (
          <Footer isLoading={isLoading} isHasMore={isHasMore} />
        )}
        // renderSeparator={separator}
        renderRow={row}
        style={{
          height: this.state.height,
          overflow: 'auto',
        }}
        onEndReached={this.onEndReached}
        pullToRefresh={
          <APullToRefresh
            refreshing={isRefreshing}
            onRefresh={this.onRefresh}
          />
        }
      />
        {
          (cookie.get('app_Type') === '3') ? 
            <div className="subBtn">
              <div className="submit-buttom">
                <Button  className='primaryColor' onClick={() => this.bookingRoom('3')}>
                  申请员工宿舍
                </Button>
              </div>
            </div>
          :
          ((cookie.get('app_Type') === '1') ? 
            <div className="subBtn">
              <div className="submit-buttom">
                <Button  className='dangerColor' onClick={() => this.bookingRoom('1')}>
                  申请招待所
                </Button>
              </div>
            </div>
            : 
            <div className="subBtn">
              <div className="submit-buttom1">
                <Button  className='primaryColor' onClick={() => this.bookingRoom('3')}>
                  申请员工宿舍
                </Button>
              </div>
              <div className="submit-buttom2">
                <Button  className='dangerColor' onClick={() => this.bookingRoom('1')}>
                  申请招待所
                </Button>
              </div>
            </div>
        )}
      </div>
    )
  }
}